// Barva osoby je deterministická z jejího id — stejný člověk má stejnou barvu
// v kalendáři, filtrech i na aktivitách, bez ukládání do DB.
// Paleta záměrně NEobsahuje zelenou, modrou ani červenou — ty v kalendáři
// znamenají stav události (hotovo / otevřené / po termínu) a barva osoby
// se s nimi nesmí plést.
const PALETA = [
  "#8b5cf6", // fialová
  "#0d9488", // petrolejová
  "#d97706", // jantarová
  "#db2777", // magenta
  "#65a30d", // olivová
  "#0891b2", // tyrkysová
  "#9333ea", // purpurová
  "#c2410c", // terakota
];

export function barvaOsoby(userId) {
  let h = 0;
  for (const ch of String(userId || "")) h = (h * 31 + ch.charCodeAt(0)) >>> 0;
  return PALETA[h % PALETA.length];
}

export function inicialy(jmeno) {
  return (jmeno || "?").split(/\s+/).map((s) => s[0]).filter(Boolean).slice(0, 2).join("").toUpperCase();
}
